import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchAdmin, deleteAdmin, editAdmin, clearAdminsErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import EditAdmin from '../components/admins/EditAdmin';
import Alert from '../components/home/Alert';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  admin: PropTypes.object,
  admins: PropTypes.object,
  adminId: PropTypes.string.isRequired,
  error: PropTypes.any,
  query: PropTypes.object,
};

class AdminEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchAdmin(this.props.adminId));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.admin && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Admin edited succesfully!',
        error: false,
      });
    }
  }
  saveEditAdmin(admin) {
    this.setState({
      edited: true,
    });
    this.props.dispatch(editAdmin(admin));
  }
  deleteAdmin(adminId) {
    const admins = this.props.admins;
    admins.delete = true;
    this.setState({ admins });
    this.props.dispatch(deleteAdmin(adminId));
    browserHistory.push('/admins?page=1');
  }
  navigateToView(location) {
    const nextState = this.state;
    nextState.viewRedirect = true;
    nextState.edited = true;
    this.setState(nextState);
    this.props.dispatch(editAdmin(location));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearAdminsErrors());
    if (!this.state.error) {
      if (this.state.viewRedirect === true) {
        this.setState({ viewRedirect: false });
        browserHistory.push(`/admins/view/${this.props.admin.id}`);
      } else {
        browserHistory.push('/admins?page=1');
      }
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="admins component" style={authPage}>
        <h2>Edit Admin</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditAdmin
            admin={this.props.admin}
            onSave={data => this.saveEditAdmin(data)}
            onDelete={data => this.deleteAdmin(data)}
            onView={data => this.navigateToView(data)}
          />
        </div>
      </div>
    );
  }
}

AdminEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

AdminEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    admin: state.admins.admin,
    admins: state.admins,
    adminId: ownProps.params.id,
    error: state.admins.error,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(AdminEditPage));



// WEBPACK FOOTER //
// ./src/containers/AdminEditPage.js